<template>
    <div class="simple-form">
        <div class="form-group">
            <div class="form-label">
                <label>规则编码</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.code}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>商户资产属性</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.custAssetNatureName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>系统资产属性</label>
            </div>
            <div class="form-value">
                <span>{{assetNatureMap[deprSpec.assetNature]}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>算法</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.deprMethodName}}</span>
            </div>
        </div>
        <div class="form-group" v-if="deprSpec.allotAcntMethod != 0">
            <div class="form-label">
                <label>转移核算方式</label>
            </div>
            <div class="form-value">
                <span>{{allotAcntMethodMap[deprSpec.allotAcntMethod]}}</span>
            </div>
        </div>
        <div class="form-group" v-if="deprSpec.allotAcntMethod == 2">
            <div class="form-label">
                <label>摊销比例(%)</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.transWorthRatio}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>规则名称</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.name}}</span>
            </div>
        </div>
        <div class="form-group" v-if="deprSpec.deprMethodCode == 'SLD' || deprSpec.deprMethodCode == 'ASM'">
            <div class="form-label">
                <label>残值率(%)</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.rmnWorthRatio}}</span>
            </div>
        </div>
        <div class="form-group" v-if="deprSpec.deprMethodCode == 'SLD' || deprSpec.deprMethodCode == 'ASM'">
            <div class="form-label">
                <label>首次计提</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.deprOn1stMonth ? '当月' : '次月'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{deprSpec.createTime}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import assetStockApi from '../../api/asset'

    export default {
        name: 'swb-depr-spec-detail',
        desc: '折旧规格详情',
        props: ["id"],
        data: function () {
            return {
                deprSpec: {},
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                allotAcntMethodMap: getEnumMap('allotAcntMethod', 'value2text')
            }
        },
        created: function () {
            this.getDeprSpec(this.id);
        },
        methods: {
            getDeprSpec: function (id) {
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                assetStockApi.getDeprSpec({
                    id: id
                }, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.deprSpec = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/DeprSpecDetail.vue